module.exports = __webpack_public_path__ + "static/media/mobile_still.f8538ba6.jpg";